import React from "react";
import { Container, Row, Col } from "reactstrap";
import chooseImg from "../assests/images/why-ezshiksha-clarity.jpg";

const points = [
  "Instant math solutions when homework stalls",
  "Concise notes generated from dense paragraphs",
  "Text extraction from images for faster research",
  "Accessible tools designed for everyday study",
];

const ChooseUs = () => {
  return (
    <section className="bg-brand-surface py-20">
      <Container>
        <Row className="items-center gy-5 gx-4 gx-lg-5">
          <Col lg="6" md="6">
            <p className="section-label">Why EzShiksha</p>
            <h2 className="mb-4">Clarity over clutter</h2>
            <p className="mb-6">
              Choose tools that respect your time. EzShiksha pairs practical AI
              helpers with a simple flow so you spend less time formatting and
              more time learning.
            </p>
            <ul className="m-0 flex list-none flex-col gap-3.5 p-0">
              {points.map((point) => (
                <li
                  key={point}
                  className="flex items-start gap-3 font-display text-base font-medium leading-snug text-brand-forest"
                >
                  <i className="ri-sparkling-2-line mt-0.5 text-[1.15rem] text-brand-teal" />
                  {point}
                </li>
              ))}
            </ul>
          </Col>

          <Col lg="6" md="6">
            <div className="relative aspect-[16/10] w-full overflow-hidden rounded-3xl bg-brand-forest shadow-brand">
              <img
                src={chooseImg}
                alt="Student using EzShiksha for math, notes, and text extraction"
                className="block h-full w-full object-cover object-center"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ChooseUs;
